<template>
  <nav
    v-if="links"
    class="d-flex underline-nav"
  >
    <div
      v-for="(link, i) in links"
      :key="i"
      :class="{ active: isActive(link) }"
    >
      <a
        v-if="!isReactive"
        :href="link.href"
        :disabled="link.disabled"
        :class="link?.class"
      >
        <i
          v-if="link.icon"
          :class="link.icon"
        ></i>
        {{ link.title }}

        <span
          v-if="link.count && link.count > 0"
          class="badge badge-pill badge-secondary"
        >
          {{ link.count }}
        </span>
      </a>
      <router-link
        v-else
        :to="{ ...link.to, params: link.to.params }"
        active-class="active"
        :class="link?.class"
        :exact="isExact"
      >
        <i
          v-if="link.icon"
          :class="link.icon"
          class="mr-1"
        ></i>
        {{ link.title }}
        <span
          v-if="link.count && link.count > 0"
          class="badge badge-pill badge-secondary"
        >
          {{ link.count }}
        </span>
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavigationTabs',
  props: {
    links: {
      default: null,
      type: Array
    },
    isReactive: {
      default: false,
      type: Boolean
    },
    // полное совпадение с query
    isExact: {
      type: Boolean,
      default: false
    },
    // текущий router включает в себя query
    includesQuery: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isActive(link) {
      if (this.isExact) {
        return (
          (this.$route.name === (!this.isReactive ? link.name : link.to.name) ||
            this.$route.name === link?.to?.additionalName) &&
          JSON.stringify(this.$route.query) === JSON.stringify(link.to.query || {})
        );
      }
      if (this.includesQuery && this.isReactive) {
        let includedQuery = true;
        Object.keys(link?.to?.query).forEach((paramKey) => {
          if (
            JSON.stringify(link?.to?.query[paramKey]) !==
            JSON.stringify(this.$route?.query[paramKey])
          ) {
            includedQuery = false;
          }
        });
        return includedQuery;
      }
      return (
        this.$route.name === (!this.isReactive ? link.name : link.to.name) ||
        this.$route.name === link?.to?.additionalName
      );
    }
  }
};
</script>
